<template>
  <a-row :gutter="20">
    <a-col :span="selectedRowKeys.length > 0 ? 12 : 12">
      <a-card :bordered="false">
        <!-- 查询区域 -->
        <div class="table-page-search-wrapper">
          <a-form class="div-query-banner" layout="inline" @keyup.enter.native="searchQuery">
            <a-form-item label="服务名称">
              <j-input placeholder="请输入服务名称" v-model="queryParam.name"></j-input>
            </a-form-item>
            <a-form-item label="地址ip">
              <a-input placeholder="ip地址" v-model="queryParam.serverId"></a-input>
            </a-form-item>
            <template v-if="toggleSearchStatus">
              <a-form-item label="端口号">
                <a-input placeholder="请输入端口号" v-model="queryParam.port"></a-input>
              </a-form-item>
              <a-form-item label="分类">
                <j-dict-select-tag
                  placeholder="请选择分类"
                  v-model="queryParam.type"
                  dictCode="bus_server_service_type"
                />
              </a-form-item>
            </template>
            <a-button class="query-banner-btn" type="primary" @click="searchQuery" icon="search">查询</a-button>
            <a-button class="query-banner-btn" type="primary" @click="searchReset" icon="reload">重置</a-button>
            <a @click="handleToggleSearch">
              {{ toggleSearchStatus ? '收起' : '展开' }}
              <a-icon :type="toggleSearchStatus ? 'up' : 'down'" />
            </a>
          </a-form>
        </div>
        <!-- 查询区域-END -->

        <!-- 操作按钮区域 -->
        <div class="table-operator">
          <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
        </div>

        <!-- table区域-begin -->
        <div>
          <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
            <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
            <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
            >项
            <a style="margin-left: 24px" @click="onClearSelected">清空</a>
          </div>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :scroll="{x:'max-content'}"
            :loading="loading"
            :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange, type: 'radio' }"
            @change="handleTableChange"
            :customRow="customRow"
          >
            <template slot="izActivity" slot-scope="text">
              <span v-if="text === 1" class="green">启用</span>
              <span v-if="text === 0" class="red">禁用</span>
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="handleEdit(record)">编辑</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
                <a-menu slot="overlay">
                  <a-menu-item>
                    <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                      <a>删除</a>
                    </a-popconfirm>
                  </a-menu-item>
                </a-menu>
              </a-dropdown>
            </span>
          </a-table>
        </div>
        <busServermanageService-modal ref="modalForm" @ok="modalFormOk"></busServermanageService-modal>
      </a-card>
    </a-col>
    <a-col v-if="selectedRowKeys.length > 0" :span="12">
      <app-list ref="appList" :serviceId="selectedRowKeys[0]"></app-list>
    </a-col>
  </a-row>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import BusServermanageServiceModal from './modules/BusServermanageServiceModal'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import AppList from './components/AppList.vue'
import JInput from '@/components/jeecg/JInput.vue'
export default {
  name: 'BusServermanageServiceList',
  mixins: [JeecgListMixin],
  components: {
    JDictSelectTag,
    BusServermanageServiceModal,
    AppList,
    JInput,
  },
  data() {
    return {
      description: '服务器管理______服务表管理页面',
      // 表头
      columns: [
      {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        // {
        //   title: '排序',
        //   align: 'center',
        //   dataIndex: 'sort',
        // },
        {
          title: '服务名称',
          align: 'center',
          dataIndex: 'name',
        },
        {
          title: '所属服务器ip',
          align: 'center',
          dataIndex: 'serverId_dictText',
        },
        {
          title: '端口号',
          align: 'center',
          dataIndex: 'port',
        },
        {
          title: '分类',
          align: 'center',
          dataIndex: 'type_dictText',
        },
        {
          title: '文件位置',
          align: 'center',
          dataIndex: 'fileSrc',
        },
        {
          title: '启用',
          align: 'center',
          dataIndex: 'izActivity',
          scopedSlots: {
            customRender: 'izActivity',
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed:"right"
        },
      ],
      /* 排序参数 */
      isorter: {
        column: 'sort',
        order: 'asc',
      },
      url: {
        list: '/servermanage/busServermanageService/list',
        delete: '/servermanage/busServermanageService/delete',
        deleteBatch: '/servermanage/busServermanageService/deleteBatch',
        exportXlsUrl: '/servermanage/busServermanageService/exportXls',
        importExcelUrl: 'servermanage/busServermanageService/importExcel',
      },
      dictOptions: {},
      customRow: (record) => {
        return {
          on: {
            click: () => {
              this.onSelectChange([record.id], [record])
            },
          },
        }
      },
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    },
  },
  methods: {
    initDictConfig() {},
  },
  watch: {
    dataSource(newVal) {
      if (!newVal[0]) {
        return
      }
      this.onSelectChange([newVal[0].id], [newVal[0]])
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@assets/less/common.less';
.red {
  color: red;
}
.green {
  color: green;
}
.card-class {
  min-height: 900px;
}
.div-query-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > *:nth-child(n) {
    width: 200px;
  }
  & > *:nth-child(n + 2) {
    margin-left: 12px;
  }
  & > .ant-btn {
    width: 100px;
  }
  & > a {
    width: 60px;
    height: 30px;
  }
}
/deep/.row-choose-bgblue {
  background: #e6f7ff !important;
}
</style>